export const OutstandingActionPing = ({
  dataTestId,
}: {
  dataTestId?: string;
}) => (
  <span
    aria-hidden="true"
    className="absolute right-0 top-0 -mr-1 -mt-1 flex size-3"
    data-testid={dataTestId}
  >
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-800 opacity-75" />
    <span className="relative inline-flex size-3 rounded-full bg-red-700" />
  </span>
);
